import { RAW_cssValue } from "@classdojo/web/nessie/stylingLib";
import React from "react";

type RoundedIconButtonProps = React.PropsWithChildren<{
  onClick: VoidFunction;
  backgroundColor: string;
  /**
   * The name will get used for automated product events.
   * @see https://www.notion.so/classdojo/Automatic-Product-Events-for-Web-bfc580f10a914c3ba514e5ec20f8ef9e?pvs=4
   */
  "data-name": string;
}>;

export default function RoundedIconButton({
  onClick,
  backgroundColor,
  children,
  "data-name": dataName,
}: RoundedIconButtonProps) {
  return (
    <button
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: RAW_cssValue(backgroundColor),
        borderRadius: "dt_radius_round",
        border: "none",
        padding: RAW_cssValue("10px"),
        outlineColor: "transparent",
      }}
      onClick={onClick}
      data-name={dataName}
    >
      {children}
    </button>
  );
}
